<template>
    <b-dropdown
        class="ellipsis-nav bordered-menu personal-goal-nav"
        v-if="!teacherAccess"
        toggle-class="personal-goal-archived-context-menu"
        variant="primary"
        right
        text="Right align"
        no-caret>
        <template #button-content>
            <i class="fas fa-ellipsis-v"></i>
        </template>

        <b-dropdown-item
            class="btn-archive-personal-goal"
            @click.prevent.stop="unarchivePersonalGoal">
            <i class="btn-box"></i>{{ $t('personal_goals.undo_archiving') }}
        </b-dropdown-item>

        <b-dropdown-item
            class="btn-remove-personal-goal"
            @click.prevent.stop="removePersonalGoal">
            <i class="btn-remove"></i>{{ $t('common.delete_learning_goal') }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
    name: 'design-2021-personal-goal-archived-context-menu-component.vue',
    props: {
        teacherAccess: {
            type: Number,
            required: true,
            default: 0,
        },
    },

    methods: {
        removePersonalGoal() {
            this.$emit('remove-personal-goal');
        },

        unarchivePersonalGoal() {
            this.$emit('unarchive-personal-goal');
        },
    },
};
</script>

<style scoped lang="scss">
.personal-goal-nav ::v-deep {
    .btn-add-task,
    .btn-edit-personal-goal,
    .btn-archive-personal-goal {
        i {
            color: $primary;
        }
    }

    .personal-goal-archived-context-menu {
        padding-top: 0;
        top: 5px;
    }
}
</style>
